<template>
	<div class="tooltip-wrapper" tabindex="0">
		<slot></slot>
		<div class="tooltip">{{ text }}</div>
	</div>
</template>
<script setup lang="ts">
	defineProps({
		text: {
			type: String,
			required: true
		}
	});
</script>

<style scoped>
	.tooltip-wrapper {
		position: relative;
	}

	.tooltip-wrapper:focus,
	.tooltip-wrapper:hover {
		.tooltip {
			display: block;
		}
	}

	.tooltip {
		z-index: 1;
		position: absolute;
		display: none;
		right: 0;
		background-color: #333333;
		color: white;
		padding: .25em .5em;
		font-size: .8em;
		width: var(--tooltip-width, max-content);
		max-width: var(--tooltip-max-width, 90vw);
	}
</style>
